import { StateField } from '@codemirror/state';
import { Decoration, EditorView } from '@codemirror/view';

const LIQUID_TAG_REGEXP = /\{\{.*?\}\}|\{%.*?%\}/g;

const createDecorations = (doc) => {
  const decorations = [];
  const text = doc.toString();

  let match = LIQUID_TAG_REGEXP.exec(text);

  while (match) {
    const start = match.index;
    const end = start + match[0].length;
    const range = Decoration.mark({ class: 'liquid-tag' }).range(start, end);

    decorations.push(range);

    match = LIQUID_TAG_REGEXP.exec(text);
  }

  return Decoration.set(decorations);
};

export const liquidStyles = EditorView.baseTheme({
  '.liquid-tag': {
    backgroundColor: '#0066eb15',
    borderRadius: '20px',
    color: 'var(--color-white)',
    padding: '1px 4px 3px'
  },
  '.cm-line .liquid-tag::selection': {
    backgroundColor: 'rgba(0,0,0,.15) !important',
    borderRadius: 'var(--border-radius-base)'
  }
});

export const liquidHighlighting = StateField.define({
  create(state) {
    return createDecorations(state.doc);
  },
  update(decorations, tr) {
    if (tr.docChanged) {
      return createDecorations(tr.newDoc);
    }

    return decorations;
  },
  provide: (f) => EditorView.decorations.from(f)
});
